import React from "react";
import { Heart, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { PageHero, GoldBtn, OutlineBtn } from "@/components/Bits";
import { BOARD, IMAGES } from "@/config/content";
import { useDonate } from "@/context/DonateContext";

export default function Board() {
  const { openDonate } = useDonate();
  return (
    <div>
      <Seo title="Board Members" description="Meet the volunteer board leading EHSIMFFA — devoted to the legacy of Emperor Haile Selassie I and to Ethiopian scholars." path="/board" />
      <PageHero
        kicker="Our Leadership"
        title="Our Board of Directors"
        subtitle="EHSIMFFA is guided by a volunteer board of accomplished professionals united by a devotion to His Imperial Majesty's vision and to the students of Ethiopia."
      />

      <section className="mx-auto max-w-5xl px-5 sm:px-8 py-20 sm:py-28">
        <div className="space-y-px bg-gold/15">
          {BOARD.map((m, i) => (
            <Reveal key={m.name} delay={(i % 2) * 0.06} className="bg-ink">
              <article className="grid gap-6 sm:grid-cols-[220px_1fr] py-10" data-testid={`board-member-${i}`}>
                <div className="flex items-start gap-4 sm:flex-col sm:gap-4">
                  <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-full border border-gold/40 bg-ink2">
                    <img src={IMAGES.logo} alt="EHSIMFFA seal" className="h-full w-full object-cover" />
                  </div>
                  <div>
                    <h2 className="font-serif text-2xl leading-tight text-ivory">{m.name}</h2>
                    <p className="kicker mt-1 text-gold/90">{m.title}</p>
                  </div>
                </div>
                <p className="text-ivory2/85 leading-relaxed">{m.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Community photo — removed at client request */}

      <section className="mx-auto max-w-3xl px-5 sm:px-8 py-20 text-center">
        <Reveal>
          <h2 className="font-serif text-3xl sm:text-4xl font-light text-ivory">Stand with our board and our scholars.</h2>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <GoldBtn onClick={() => openDonate()} testid="board-donate"><Heart className="h-5 w-5" /> Support Our Work</GoldBtn>
            <OutlineBtn to="/contact" testid="board-contact">Contact the Foundation <ArrowRight className="h-4 w-4" /></OutlineBtn>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
